// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var MomentTimezone = require("moment-timezone");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Ticket$ReactHooksTemplate = require("./ticket.res.js");
var MomentRe$ReactHooksTemplate = require("../MomentRe.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var Organization$ReactHooksTemplate = require("../settings/organization.res.js");
var TicketActivity$ReactHooksTemplate = require("./ticketActivity.res.js");
var TicketCategory$ReactHooksTemplate = require("./ticketCategory.res.js");
var TicketHistoryView$ReactHooksTemplate = require("./TicketHistoryView.res.js");
var TicketActivityView$ReactHooksTemplate = require("./TicketActivityView.res.js");
var CurrentOrganization$ReactHooksTemplate = require("../CurrentOrganization.res.js");

function updateTicket(id, status, parkedTill, comments) {
  var statusEndpoint;
  switch (status) {
    case "Open" :
        statusEndpoint = "reopen";
        break;
    case "Parked" :
        statusEndpoint = "park";
        break;
    case "Closed" :
        statusEndpoint = "force_close";
        break;
    case "Resolved" :
        statusEndpoint = "resolve";
        break;
    
  }
  var params;
  var exit = 0;
  switch (status) {
    case "Open" :
        params = {};
        break;
    case "Parked" :
        var params$1 = {};
        params$1["parked_till"] = parkedTill;
        var ticket = {};
        ticket["ticket"] = params$1;
        params = ticket;
        break;
    case "Closed" :
    case "Resolved" :
        exit = 1;
        break;
    
  }
  if (exit === 1) {
    var params$2 = {};
    params$2["comments"] = comments;
    var ticket$1 = {};
    ticket$1["ticket"] = params$2;
    params = ticket$1;
  }
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/tickets/" + id + "/" + statusEndpoint, params);
}

function isValidComment(comment) {
  if (comment === "") {
    return false;
  } else {
    return true;
  }
}

var emptyState = {
  ticketActivities: /* [] */0,
  ticketHistory: /* [] */0,
  currentPage: "1",
  sidebarExpanded: true
};

var initialAccordionState = {
  feedbackTab: false,
  ticketTab: false,
  campaignTab: false,
  customerDetailsTab: false
};

function page(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function TicketView(props) {
  var assignTicket = props.assignTicket;
  var updateTickets = props.updateTickets;
  var ticket = props.ticket;
  var match = React.useState(function (param) {
        return "Open";
      });
  var setAction = match[1];
  var action = match[0];
  var match$1 = React.useState(function (param) {
        return "activity";
      });
  var setActiveHeader = match$1[1];
  var activeHeader = match$1[0];
  var match$2 = React.useState(function (param) {
        return "";
      });
  var setParkedTill = match$2[1];
  var parkedTill = match$2[0];
  var match$3 = React.useState(function (param) {
        return "";
      });
  var setComments = match$3[1];
  var comments = match$3[0];
  var match$4 = React.useState(function (param) {
        return "";
      });
  var setTicketComment = match$4[1];
  var ticketComment = match$4[0];
  var match$5 = React.useState(function (param) {
        return initialAccordionState;
      });
  var setAccordionState = match$5[1];
  var accordionState = match$5[0];
  var match$6 = React.useState(function (param) {
        return false;
      });
  var setOpenStatusModal = match$6[1];
  var match$7 = React.useState(function (param) {
        return false;
      });
  var setOpenAssignModal = match$7[1];
  var match$8 = React.useState(function (param) {
        return emptyState;
      });
  var setState = match$8[1];
  var state = match$8[0];
  var match$9 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match$9[0];
  var match$10 = React.useContext(CurrentOrganization$ReactHooksTemplate.authContext);
  var organizationProfile = match$10[0];
  var fetchTicketActivities = function (param) {
    var ticketId = String(Ticket$ReactHooksTemplate.id(ticket));
    return Js_promise.then_((function (param) {
                  return Js_promise.then_((function (json) {
                                return Promise.resolve(Json_decode.field("ticket_activities", (function (param) {
                                                  return Json_decode.list(TicketActivity$ReactHooksTemplate.decode, param);
                                                }), json));
                              }), param[1]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader("/api/v1/tickets/" + ticketId + "/ticket_activities"));
  };
  var fetchTicketHistory = function (pageNumber) {
    var email = Ticket$ReactHooksTemplate.email(ticket);
    var msisdn = Ticket$ReactHooksTemplate.msisdn(ticket);
    return Js_promise.then_((function (param) {
                  var x = param[0].get("Page");
                  var page = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var ticket_history = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("tickets", (function (param) {
                                            return Json_decode.list(Ticket$ReactHooksTemplate.decode, param);
                                          }), json));
                        }), param[1]);
                  return Promise.resolve([
                              ticket_history,
                              page
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader("/api/v1/tickets/tickets_by_customer?email=" + Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, email) + "&msisdn=" + Curry._1(DomainModel$ReactHooksTemplate.$$String.Msisdn.show, msisdn) + "&page=" + pageNumber));
  };
  var domElement = React.useRef(null);
  var handleScroll = function (param) {
    var element = Belt_Option.getExn(Caml_option.nullable_to_opt(domElement.current));
    var bottom = element.scrollHeight - element.scrollTop - element.clientHeight < 5.0;
    if (!bottom) {
      return ;
    }
    var page = Caml_format.int_of_string(state.currentPage);
    var pageNumber = String(page + 1 | 0);
    Js_promise.then_((function (param) {
            var page = param[1];
            return Promise.resolve(Js_promise.then_((function (ticket_history) {
                              var mergedTicketHistory = List.append(state.ticketHistory, ticket_history);
                              return Promise.resolve(Curry._1(setState, (function (param) {
                                                return {
                                                        ticketActivities: state.ticketActivities,
                                                        ticketHistory: mergedTicketHistory,
                                                        currentPage: page,
                                                        sidebarExpanded: state.sidebarExpanded
                                                      };
                                              })));
                            }), param[0]));
          }), fetchTicketHistory(pageNumber));
  };
  React.useEffect((function (param) {
          switch (activeHeader) {
            case "activity" :
                Js_promise.then_((function (activities) {
                        return Promise.resolve(Curry._1(setState, (function (state) {
                                          return {
                                                  ticketActivities: activities,
                                                  ticketHistory: state.ticketHistory,
                                                  currentPage: state.currentPage,
                                                  sidebarExpanded: state.sidebarExpanded
                                                };
                                        })));
                      }), fetchTicketActivities(state.currentPage));
                return ;
            case "ticket_history" :
                Js_promise.then_((function (param) {
                        var page = param[1];
                        return Promise.resolve(Js_promise.then_((function (ticket_history) {
                                          return Promise.resolve(Curry._1(setState, (function (param) {
                                                            return {
                                                                    ticketActivities: state.ticketActivities,
                                                                    ticketHistory: ticket_history,
                                                                    currentPage: page,
                                                                    sidebarExpanded: state.sidebarExpanded
                                                                  };
                                                          })));
                                        }), param[0]));
                      }), fetchTicketHistory(state.currentPage));
                return ;
            default:
              return ;
          }
        }), [
        ticket,
        activeHeader
      ]);
  var emailText = function (assignee) {
    return Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Ticket$ReactHooksTemplate.Assignee.email(assignee));
  };
  var handleStatusChange = function ($$event) {
    var status = Ticket$ReactHooksTemplate.Status.fromString(Utils$ReactHooksTemplate.formTargetValue($$event));
    Curry._1(setAction, (function (param) {
            return status;
          }));
    Curry._1(setOpenStatusModal, (function (param) {
            return true;
          }));
  };
  var handleParkedTillChange = function ($$event) {
    var date = Utils$ReactHooksTemplate.formTargetValue($$event);
    var toTimeWithZone = MomentTimezone.tz(date, Organization$ReactHooksTemplate.timeZone(organizationProfile));
    Curry._1(setParkedTill, (function (param) {
            return toTimeWithZone.format();
          }));
  };
  var handleCommentsChange = function ($$event) {
    var text = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setComments, (function (param) {
            return text;
          }));
  };
  var handleTicketCommentChanges = function ($$event) {
    var text = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setTicketComment, (function (param) {
            return text;
          }));
  };
  var handleSubmit = function (param) {
    var parkedMoment = MomentRe$ReactHooksTemplate.moment(undefined, parkedTill);
    var today = MomentRe$ReactHooksTemplate.moment(undefined, new Date().toISOString());
    var isParkable = parkedMoment.isAfter(today) && action === "Parked";
    var isResolved = isValidComment(comments) && action === "Resolved";
    var isValidForm = action === "Open" || action === "Closed" || isResolved || isParkable;
    if (isValidForm) {
      Js_promise.then_((function (param) {
              return Promise.resolve(Curry._2(updateTickets, Ticket$ReactHooksTemplate.id(ticket), action));
            }), Js_promise.then_((function (param) {
                  return Promise.resolve(Curry._1(setOpenStatusModal, (function (param) {
                                    return false;
                                  })));
                }), Js_promise.then_((function (response) {
                      return Promise.resolve((console.log(response), undefined));
                    }), updateTicket(String(Ticket$ReactHooksTemplate.id(ticket)), action, parkedTill, comments))));
      return ;
    }
    
  };
  var handleCommentSubmit = function (param) {
    var comment = {};
    comment["comment"] = ticketComment;
    var params = {};
    params["ticket"] = comment;
    var id = String(Ticket$ReactHooksTemplate.id(ticket));
    Js_promise.then_((function (param) {
            return Js_promise.then_((function (activities) {
                          return Promise.resolve((Curry._1(setState, (function (state) {
                                              return {
                                                      ticketActivities: activities,
                                                      ticketHistory: state.ticketHistory,
                                                      currentPage: state.currentPage,
                                                      sidebarExpanded: state.sidebarExpanded
                                                    };
                                            })), Curry._1(setTicketComment, (function (param) {
                                              return "";
                                            }))));
                        }), fetchTicketActivities(state.currentPage));
          }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/tickets/" + id + "/update_comment", params));
  };
  var displayTicketActivites = function (activity) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(TicketActivityView$ReactHooksTemplate.make, {
                      activity: activity
                    }),
                className: "w-full mb-2"
              }, String(TicketActivity$ReactHooksTemplate.id(activity)));
  };
  var displayTicketHistory = function (ticket_history) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(TicketHistoryView$ReactHooksTemplate.make, {
                      ticket_history: ticket_history
                    }),
                className: "w-full mb-2"
              }, String(Ticket$ReactHooksTemplate.id(ticket_history)));
  };
  var displayData = function (param) {
    console.log(state.ticketActivities);
    switch (activeHeader) {
      case "activity" :
          return JsxRuntime.jsx("div", {
                      children: $$Array.of_list(Belt_List.map(state.ticketActivities, displayTicketActivites)),
                      className: "flex-1 p-2 overflow-y-auto"
                    });
      case "ticket_history" :
          return JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: $$Array.of_list(Belt_List.map(state.ticketHistory, displayTicketHistory)),
                            className: "w-full"
                          }),
                      ref: Caml_option.some(domElement),
                      className: "flex-1 p-2 overflow-y-auto",
                      onScroll: handleScroll
                    });
      default:
        return JsxRuntime.jsx("div", {
                    className: "flex-1 p-3 overflow-y-auto"
                  });
    }
  };
  var match$11 = Ticket$ReactHooksTemplate.sourceType(ticket);
  var tmp;
  if (match$11 === "Transaction") {
    var tmp$1;
    if (accordionState.feedbackTab) {
      var response = Ticket$ReactHooksTemplate.normalResponses(ticket);
      tmp$1 = JsxRuntime.jsx("div", {
            children: response !== undefined ? JsxRuntime.jsx("div", {
                    children: Belt_Array.mapWithIndex(response.header, (function (i, h) {
                            return JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("span", {
                                                              children: "Q",
                                                              className: "text-white text-xs font-bold"
                                                            }),
                                                        className: "flex-shrink-0 w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center"
                                                      }),
                                                  JsxRuntime.jsx("div", {
                                                        children: h,
                                                        className: "flex-1 text-xs font-medium text-gray-900 leading-relaxed"
                                                      })
                                                ],
                                                className: "bg-blue-50 border-b border-blue-100 p-2 flex items-start gap-2"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("span", {
                                                              children: "A",
                                                              className: "text-white text-xs font-bold"
                                                            }),
                                                        className: "flex-shrink-0 w-5 h-5 rounded-full bg-green-500 flex items-center justify-center"
                                                      }),
                                                  JsxRuntime.jsx("div", {
                                                        children: Belt_Option.getWithDefault(Caml_array.get(response.contents, i), "No response provided"),
                                                        className: "flex-1 text-xs text-gray-700 leading-relaxed break-words"
                                                      })
                                                ],
                                                className: "bg-white p-2 flex items-start gap-2"
                                              })
                                        ],
                                        className: "bg-white rounded-lg border border-gray-200 overflow-hidden"
                                      }, h);
                          })),
                    className: "space-y-2"
                  }) : JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("p", {
                          children: "No feedback available",
                          className: "text-xs text-gray-500 italic"
                        }),
                    className: "text-center py-4"
                  }),
            className: "bg-gray-50 max-h-60 overflow-y-auto p-2"
          });
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx("span", {
                          children: "Feedback",
                          className: "font-medium text-xs text-gray-900"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("img", {
                                className: "h-3 w-3",
                                src: Image$ReactHooksTemplate.chevronDown
                              }),
                          className: "transition-transform duration-200 " + (
                            accordionState.feedbackTab ? "rotate-180" : ""
                          )
                        })
                  ],
                  className: "w-full flex justify-between items-center p-2 hover:bg-gray-50 transition-colors duration-200 border-b border-gray-100",
                  onClick: (function (param) {
                      Curry._1(setAccordionState, (function (accordionState) {
                              return {
                                      feedbackTab: !accordionState.feedbackTab,
                                      ticketTab: accordionState.ticketTab,
                                      campaignTab: accordionState.campaignTab,
                                      customerDetailsTab: accordionState.customerDetailsTab
                                    };
                            }));
                    })
                }),
            tmp$1
          ],
          className: "bg-white rounded-lg border border-gray-200 overflow-hidden"
        });
  } else {
    tmp = null;
  }
  var tmp$2;
  if (accordionState.customerDetailsTab) {
    var channel = Ticket$ReactHooksTemplate.channel(ticket);
    var touchPoint = Ticket$ReactHooksTemplate.touchPoint(ticket);
    var details = Ticket$ReactHooksTemplate.moreDetails(ticket);
    tmp$2 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("span", {
                                children: "Phone",
                                className: "text-xs font-medium text-gray-600"
                              }),
                          JsxRuntime.jsx("span", {
                                children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Msisdn.show, Ticket$ReactHooksTemplate.msisdn(ticket)),
                                className: "text-xs text-gray-900"
                              })
                        ],
                        className: "flex justify-between items-center"
                      }),
                  className: "p-1.5 bg-white rounded border border-gray-200"
                }),
            JsxRuntime.jsx("div", {
                  children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Ticket$ReactHooksTemplate.email(ticket)).length > 30 ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: "Email",
                                  className: "text-xs font-medium text-gray-600 mb-0.5"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Ticket$ReactHooksTemplate.email(ticket)),
                                  className: "text-xs text-gray-900 break-all"
                                })
                          ]
                        }) : JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: "Email",
                                  className: "text-xs font-medium text-gray-600"
                                }),
                            JsxRuntime.jsx("span", {
                                  children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Ticket$ReactHooksTemplate.email(ticket)),
                                  className: "text-xs text-gray-900"
                                })
                          ],
                          className: "flex justify-between items-center"
                        }),
                  className: "p-1.5 bg-white rounded border border-gray-200"
                }),
            channel !== undefined ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: "Channel",
                                  className: "text-xs font-medium text-gray-600"
                                }),
                            JsxRuntime.jsx("span", {
                                  children: channel,
                                  className: "text-xs text-gray-900"
                                })
                          ],
                          className: "flex justify-between items-center"
                        }),
                    className: "p-1.5 bg-white rounded border border-gray-200"
                  }) : null,
            touchPoint !== undefined ? JsxRuntime.jsx("div", {
                    children: touchPoint.length > 30 ? JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Touch Point",
                                    className: "text-xs font-medium text-gray-600 mb-0.5"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: touchPoint,
                                    className: "text-xs text-gray-900 break-words"
                                  })
                            ]
                          }) : JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("span", {
                                    children: "Touch Point",
                                    className: "text-xs font-medium text-gray-600"
                                  }),
                              JsxRuntime.jsx("span", {
                                    children: touchPoint,
                                    className: "text-xs text-gray-900"
                                  })
                            ],
                            className: "flex justify-between items-center"
                          }),
                    className: "p-1.5 bg-white rounded border border-gray-200"
                  }) : null,
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("span", {
                                children: "Transaction Date",
                                className: "text-xs font-medium text-gray-600"
                              }),
                          JsxRuntime.jsx("span", {
                                children: Ticket$ReactHooksTemplate.transactionDate(ticket).format("MMM DD, YYYY"),
                                className: "text-xs text-gray-900"
                              })
                        ],
                        className: "flex justify-between items-center"
                      }),
                  className: "p-1.5 bg-white rounded border border-gray-200"
                }),
            details !== undefined ? Belt_Array.mapWithIndex(details.header, (function (i, h) {
                      var value = Belt_Option.getWithDefault(Caml_array.get(details.contents, i), "N/A");
                      var isLongField = h.length > 25;
                      var isLongValue = value.length > 30;
                      return JsxRuntime.jsx("div", {
                                  children: isLongField || isLongValue ? JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: h,
                                                  className: "text-xs font-medium text-gray-600 mb-0.5 break-words"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: value,
                                                  className: "text-xs text-gray-900 break-words"
                                                })
                                          ]
                                        }) : JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("span", {
                                                  children: h,
                                                  className: "text-xs font-medium text-gray-600 flex-shrink-0 mr-2"
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: value,
                                                  className: "text-xs text-gray-900 text-right"
                                                })
                                          ],
                                          className: "flex justify-between items-center"
                                        }),
                                  className: "p-1.5 bg-white rounded border border-gray-200"
                                }, h);
                    })) : null
          ],
          className: "p-2 bg-gray-50 space-y-1 max-h-60 overflow-y-auto"
        });
  } else {
    tmp$2 = null;
  }
  var match$12 = Ticket$ReactHooksTemplate.sourceType(ticket);
  var tmp$3;
  if (match$12 === "Transaction") {
    var tmp$4;
    if (accordionState.campaignTab) {
      var channel$1 = Ticket$ReactHooksTemplate.channel(ticket);
      var touchPoint$1 = Ticket$ReactHooksTemplate.touchPoint(ticket);
      var lob = Ticket$ReactHooksTemplate.lob(ticket);
      var esc_level_2 = Ticket$ReactHooksTemplate.escalation_level_2(ticket);
      var esc_level_3 = Ticket$ReactHooksTemplate.escalation_level_3(ticket);
      var esc_level_4 = Ticket$ReactHooksTemplate.escalation_level_4(ticket);
      var esc_level_5 = Ticket$ReactHooksTemplate.escalation_level_5(ticket);
      tmp$4 = JsxRuntime.jsxs("div", {
            children: [
              channel$1 !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "Channel",
                              className: "text-xs text-gray-600"
                            }),
                        JsxRuntime.jsx("span", {
                              children: channel$1,
                              className: "text-xs text-gray-900"
                            })
                      ],
                      className: "flex justify-between items-center p-1.5 bg-white rounded border border-gray-200"
                    }) : null,
              touchPoint$1 !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "Touch Point",
                              className: "text-xs text-gray-600"
                            }),
                        JsxRuntime.jsx("span", {
                              children: touchPoint$1,
                              className: "text-xs text-gray-900"
                            })
                      ],
                      className: "flex justify-between items-center p-1.5 bg-white rounded border border-gray-200"
                    }) : null,
              lob !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "LOB",
                              className: "text-xs text-gray-600"
                            }),
                        JsxRuntime.jsx("span", {
                              children: lob,
                              className: "text-xs text-gray-900"
                            })
                      ],
                      className: "flex justify-between items-center p-1.5 bg-white rounded border border-gray-200"
                    }) : null,
              esc_level_2 !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "Esc Level 2",
                              className: "text-xs text-gray-600"
                            }),
                        JsxRuntime.jsx("span", {
                              children: esc_level_2,
                              className: "text-xs text-gray-900 truncate ml-2"
                            })
                      ],
                      className: "flex justify-between items-center p-1.5 bg-white rounded border border-gray-200"
                    }) : null,
              esc_level_3 !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "Esc Level 3",
                              className: "text-xs text-gray-600"
                            }),
                        JsxRuntime.jsx("span", {
                              children: esc_level_3,
                              className: "text-xs text-gray-900 truncate ml-2"
                            })
                      ],
                      className: "flex justify-between items-center p-1.5 bg-white rounded border border-gray-200"
                    }) : null,
              esc_level_4 !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "Esc Level 4",
                              className: "text-xs text-gray-600"
                            }),
                        JsxRuntime.jsx("span", {
                              children: esc_level_4,
                              className: "text-xs text-gray-900 truncate ml-2"
                            })
                      ],
                      className: "flex justify-between items-center p-1.5 bg-white rounded border border-gray-200"
                    }) : null,
              esc_level_5 !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "Esc Level 5",
                              className: "text-xs text-gray-600"
                            }),
                        JsxRuntime.jsx("span", {
                              children: esc_level_5,
                              className: "text-xs text-gray-900 truncate ml-2"
                            })
                      ],
                      className: "flex justify-between items-center p-1.5 bg-white rounded border border-gray-200"
                    }) : null
            ],
            className: "p-2 bg-gray-50 space-y-1 max-h-60 overflow-y-auto"
          });
    } else {
      tmp$4 = null;
    }
    tmp$3 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx("span", {
                          children: "Campaign",
                          className: "font-medium text-xs text-gray-900"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("img", {
                                className: "h-3 w-3",
                                src: Image$ReactHooksTemplate.chevronDown
                              }),
                          className: "transition-transform duration-200 " + (
                            accordionState.campaignTab ? "rotate-180" : ""
                          )
                        })
                  ],
                  className: "w-full flex justify-between items-center p-2 hover:bg-gray-50 transition-colors duration-200 border-b border-gray-100",
                  onClick: (function (param) {
                      Curry._1(setAccordionState, (function (accordionState) {
                              return {
                                      feedbackTab: accordionState.feedbackTab,
                                      ticketTab: accordionState.ticketTab,
                                      campaignTab: !accordionState.campaignTab,
                                      customerDetailsTab: accordionState.customerDetailsTab
                                    };
                            }));
                    })
                }),
            tmp$4
          ],
          className: "bg-white rounded-lg border border-gray-200 overflow-hidden"
        });
  } else {
    tmp$3 = null;
  }
  var tmp$5;
  if (match$6[0]) {
    var tmp$6;
    switch (action) {
      case "Open" :
          tmp$6 = "Reopen Ticket";
          break;
      case "Parked" :
          tmp$6 = "Park Ticket";
          break;
      case "Closed" :
          tmp$6 = "Close Ticket";
          break;
      case "Resolved" :
          tmp$6 = "Resolve Ticket";
          break;
      
    }
    var tmp$7;
    switch (action) {
      case "Open" :
          tmp$7 = JsxRuntime.jsx("p", {
                children: "Are you sure you want to reopen this ticket?",
                className: "text-sm text-gray-600"
              });
          break;
      case "Parked" :
          tmp$7 = JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("label", {
                        children: "Reactivate on",
                        className: "block text-xs font-medium text-gray-700 mb-2"
                      }),
                  JsxRuntime.jsx("input", {
                        className: "block w-full border border-gray-300 px-3 py-2 rounded\n                        focus:outline-none focus:ring-2 focus:ring-palatinateblue focus:border-palatinateblue\n                        text-sm transition-all duration-200",
                        type: "date",
                        onChange: handleParkedTillChange
                      })
                ]
              });
          break;
      case "Closed" :
          tmp$7 = JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("label", {
                        children: "Comments",
                        className: "block text-xs font-medium text-gray-700 mb-2"
                      }),
                  JsxRuntime.jsx("textarea", {
                        className: "w-full block border border-gray-300 px-3 py-2 rounded\n                        focus:outline-none focus:ring-2 focus:ring-palatinateblue focus:border-palatinateblue\n                        text-sm transition-all duration-200",
                        placeholder: "Add closing comments...",
                        rows: 3,
                        value: comments,
                        onChange: handleCommentsChange
                      })
                ]
              });
          break;
      case "Resolved" :
          tmp$7 = JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("label", {
                        children: "Root Cause Analysis (RCA)",
                        className: "block text-xs font-medium text-gray-700 mb-2"
                      }),
                  JsxRuntime.jsx("textarea", {
                        className: "w-full block border border-gray-300 px-3 py-2 rounded\n                        focus:outline-none focus:ring-2 focus:ring-palatinateblue focus:border-palatinateblue\n                        text-sm transition-all duration-200",
                        placeholder: "Describe the root cause and resolution...",
                        rows: 3,
                        value: comments,
                        onChange: handleCommentsChange
                      })
                ]
              });
          break;
      
    }
    var tmp$8;
    switch (action) {
      case "Open" :
          tmp$8 = "Reopen";
          break;
      case "Parked" :
          tmp$8 = "Park";
          break;
      case "Closed" :
          tmp$8 = "Close";
          break;
      case "Resolved" :
          tmp$8 = "Resolve";
          break;
      
    }
    tmp$5 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h3", {
                                children: tmp$6,
                                className: "text-base font-semibold text-gray-900"
                              }),
                          JsxRuntime.jsx("button", {
                                children: JsxRuntime.jsx("img", {
                                      className: "h-4 w-4",
                                      src: Image$ReactHooksTemplate.closeIcon
                                    }),
                                className: "text-gray-400 hover:text-gray-600 transition-colors",
                                onClick: (function (param) {
                                    Curry._1(setOpenStatusModal, (function (param) {
                                            return false;
                                          }));
                                  })
                              })
                        ],
                        className: "p-4 border-b border-gray-200 flex justify-between items-center"
                      }),
                  JsxRuntime.jsx("div", {
                        children: tmp$7,
                        className: "p-4"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("button", {
                                children: "Cancel",
                                className: "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50\n                    rounded py-2 px-4 text-sm font-medium transition-all duration-200",
                                onClick: (function (param) {
                                    Curry._1(setOpenStatusModal, (function (param) {
                                            return false;
                                          }));
                                  })
                              }),
                          JsxRuntime.jsx("button", {
                                children: tmp$8,
                                className: "bg-palatinateblue text-white hover:bg-blue-700\n                    rounded py-2 px-4 text-sm font-medium transition-all duration-200 shadow-sm",
                                onClick: handleSubmit
                              })
                        ],
                        className: "p-4 border-t border-gray-200 flex justify-end gap-2 bg-gray-50"
                      })
                ],
                className: "bg-white rounded-lg shadow-2xl border border-gray-200 w-96 max-w-md",
                onClick: (function (e) {
                    e.stopPropagation();
                  })
              }),
          className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
          onClick: (function (param) {
              Curry._1(setOpenStatusModal, (function (param) {
                      return false;
                    }));
            })
        });
  } else {
    tmp$5 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("span", {
                                                                children: "#" + String(Ticket$ReactHooksTemplate.id(ticket)),
                                                                className: "text-lg font-bold text-gray-900"
                                                              }),
                                                          JsxRuntime.jsx("div", {
                                                                children: TicketCategory$ReactHooksTemplate.name(Ticket$ReactHooksTemplate.ticketCategory(ticket)),
                                                                className: "inline-flex items-center px-2 py-1 rounded text-xs font-medium text-white",
                                                                style: {
                                                                  backgroundColor: TicketCategory$ReactHooksTemplate.colorToString(TicketCategory$ReactHooksTemplate.color(Ticket$ReactHooksTemplate.ticketCategory(ticket)))
                                                                }
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "h-3.5 w-3.5 mr-1.5",
                                                                        src: Image$ReactHooksTemplate.clockCircle
                                                                      }),
                                                                  JsxRuntime.jsx("span", {
                                                                        children: Ticket$ReactHooksTemplate.createdAt(ticket).format("MMM DD, h:mm A")
                                                                      })
                                                                ],
                                                                className: "flex items-center text-xs text-gray-500"
                                                              })
                                                        ],
                                                        className: "flex items-center gap-3"
                                                      }),
                                                  JsxRuntime.jsx("button", {
                                                        children: JsxRuntime.jsx("svg", {
                                                              children: state.sidebarExpanded ? JsxRuntime.jsx("path", {
                                                                      d: "M13 5l7 7-7 7M5 5l7 7-7 7",
                                                                      strokeLinecap: "round",
                                                                      strokeLinejoin: "round",
                                                                      strokeWidth: "2"
                                                                    }) : JsxRuntime.jsx("path", {
                                                                      d: "M11 19l-7-7 7-7m8 14l-7-7 7-7",
                                                                      strokeLinecap: "round",
                                                                      strokeLinejoin: "round",
                                                                      strokeWidth: "2"
                                                                    }),
                                                              className: "w-5 h-5",
                                                              fill: "none",
                                                              stroke: "currentColor",
                                                              viewBox: "0 0 24 24"
                                                            }),
                                                        className: "text-gray-600 hover:text-palatinateblue transition-colors duration-200",
                                                        title: state.sidebarExpanded ? "Collapse sidebar" : "Expand sidebar",
                                                        onClick: (function (param) {
                                                            Curry._1(setState, (function (s) {
                                                                    return {
                                                                            ticketActivities: s.ticketActivities,
                                                                            ticketHistory: s.ticketHistory,
                                                                            currentPage: s.currentPage,
                                                                            sidebarExpanded: !s.sidebarExpanded
                                                                          };
                                                                  }));
                                                          })
                                                      })
                                                ],
                                                className: "flex justify-between items-center"
                                              }),
                                          className: "bg-white border-b border-gray-200 p-3 flex-shrink-0"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("nav", {
                                                        children: [
                                                          Curry._1(hasPermission, "ShowDistribution") ? JsxRuntime.jsx("button", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx("span", {
                                                                                children: "Activity"
                                                                              }),
                                                                          JsxRuntime.jsx("span", {
                                                                                children: String(Belt_List.length(state.ticketActivities)),
                                                                                className: "bg-blue-100 text-blue-700 text-xs font-medium px-1 py-0.5 rounded"
                                                                              })
                                                                        ],
                                                                        className: "flex items-center gap-1"
                                                                      }),
                                                                  className: "py-2 px-1 border-b-2 font-medium text-xs transition-all duration-200 " + (
                                                                    activeHeader === "activity" ? "border-palatinateblue text-palatinateblue" : "border-transparent text-gray-500 hover:text-gray-700"
                                                                  ),
                                                                  onClick: (function (param) {
                                                                      Curry._1(setActiveHeader, (function (param) {
                                                                              return "activity";
                                                                            }));
                                                                    })
                                                                }) : null,
                                                          Curry._1(hasPermission, "ShowReport") ? JsxRuntime.jsx("button", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx("span", {
                                                                                children: "History"
                                                                              }),
                                                                          JsxRuntime.jsx("span", {
                                                                                children: String(Belt_List.length(state.ticketHistory)),
                                                                                className: "bg-purple-100 text-purple-700 text-xs font-medium px-1 py-0.5 rounded"
                                                                              })
                                                                        ],
                                                                        className: "flex items-center gap-1"
                                                                      }),
                                                                  className: "py-2 px-1 border-b-2 font-medium text-xs transition-all duration-200 " + (
                                                                    activeHeader === "ticket_history" ? "border-palatinateblue text-palatinateblue" : "border-transparent text-gray-500 hover:text-gray-700"
                                                                  ),
                                                                  onClick: (function (param) {
                                                                      Curry._1(setActiveHeader, (function (param) {
                                                                              return "ticket_history";
                                                                            }));
                                                                    })
                                                                }) : null,
                                                          Curry._1(hasPermission, "ShowReport") ? JsxRuntime.jsx("button", {
                                                                  children: "User Log",
                                                                  className: "py-2 px-1 border-b-2 font-medium text-xs transition-all duration-200 " + (
                                                                    activeHeader === "user_log" ? "border-palatinateblue text-palatinateblue" : "border-transparent text-gray-500 hover:text-gray-700"
                                                                  ),
                                                                  onClick: (function (param) {
                                                                      Curry._1(setActiveHeader, (function (param) {
                                                                              return "user_log";
                                                                            }));
                                                                    })
                                                                }) : null
                                                        ],
                                                        className: "flex gap-4"
                                                      }),
                                                  className: "bg-white border-b border-gray-200 px-3 py-1 flex-shrink-0"
                                                }),
                                            displayData()
                                          ],
                                          className: "flex-1 flex flex-col min-h-0 overflow-hidden"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsxs("button", {
                                                                children: [
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "h-3.5 w-3.5 mr-1.5",
                                                                        src: Image$ReactHooksTemplate.share
                                                                      }),
                                                                  "Share"
                                                                ],
                                                                className: "bg-gray-100 text-gray-400 border border-gray-300\n                    flex items-center rounded py-1.5 px-3 text-xs font-medium cursor-not-allowed",
                                                                id: "share",
                                                                disabled: true
                                                              }),
                                                          Curry._1(hasPermission, "ManageTickets") ? JsxRuntime.jsxs("button", {
                                                                  children: [
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "h-3.5 w-3.5 mr-1.5",
                                                                          src: Image$ReactHooksTemplate.userPlus
                                                                        }),
                                                                    "Assign"
                                                                  ],
                                                                  className: "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50\n                        flex items-center rounded py-1.5 px-3 text-xs font-medium\n                        transition-all duration-200",
                                                                  id: "assign",
                                                                  onClick: (function (param) {
                                                                      Curry._1(setOpenAssignModal, (function (param) {
                                                                              return true;
                                                                            }));
                                                                    })
                                                                }) : null,
                                                          JsxRuntime.jsxs("button", {
                                                                children: [
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "h-3.5 w-3.5 mr-1.5",
                                                                        src: Image$ReactHooksTemplate.calendar
                                                                      }),
                                                                  "Schedule"
                                                                ],
                                                                className: "bg-gray-100 text-gray-400 border border-gray-300\n                    flex items-center rounded py-1.5 px-3 text-xs font-medium cursor-not-allowed",
                                                                id: "schedule",
                                                                disabled: true
                                                              })
                                                        ],
                                                        className: "flex gap-2"
                                                      }),
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("span", {
                                                                      children: "Status:",
                                                                      className: "text-gray-600 text-xs font-medium mr-1.5"
                                                                    }),
                                                                JsxRuntime.jsxs("select", {
                                                                      children: [
                                                                        JsxRuntime.jsx("option", {
                                                                              children: Ticket$ReactHooksTemplate.Status.toString(Ticket$ReactHooksTemplate.status(ticket)),
                                                                              value: Ticket$ReactHooksTemplate.Status.toString(Ticket$ReactHooksTemplate.status(ticket))
                                                                            }, Ticket$ReactHooksTemplate.Status.toString(Ticket$ReactHooksTemplate.status(ticket))),
                                                                        $$Array.of_list(List.map((function (status) {
                                                                                    return JsxRuntime.jsx("option", {
                                                                                                children: Ticket$ReactHooksTemplate.Status.toString(status),
                                                                                                value: Ticket$ReactHooksTemplate.Status.toString(status)
                                                                                              }, Ticket$ReactHooksTemplate.Status.toString(status));
                                                                                  }), Ticket$ReactHooksTemplate.Status.next(Ticket$ReactHooksTemplate.status(ticket))))
                                                                      ],
                                                                      className: "bg-white text-xs font-semibold text-gray-900 focus:outline-none cursor-pointer",
                                                                      value: Ticket$ReactHooksTemplate.Status.toString(Ticket$ReactHooksTemplate.status(ticket)),
                                                                      onChange: handleStatusChange
                                                                    })
                                                              ],
                                                              className: "flex items-center bg-white border border-gray-300 rounded py-1 px-2"
                                                            }),
                                                        className: "flex gap-2"
                                                      })
                                                ],
                                                className: "flex items-center justify-between gap-2"
                                              }),
                                          className: "border-t border-gray-200 bg-gray-50 p-2 flex-shrink-0"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("input", {
                                                        className: "flex-1 px-3 py-2 border border-gray-300 rounded\n                  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500\n                  transition-all duration-200 text-xs",
                                                        placeholder: "Add a comment...",
                                                        type: "text",
                                                        value: ticketComment,
                                                        onChange: handleTicketCommentChanges
                                                      }),
                                                  JsxRuntime.jsxs("button", {
                                                        children: [
                                                          JsxRuntime.jsx("img", {
                                                                className: "h-3.5 w-3.5",
                                                                src: Image$ReactHooksTemplate.submit
                                                              }),
                                                          "Send"
                                                        ],
                                                        className: "bg-blue-500 text-white px-4 py-2 rounded font-medium text-xs\n                  hover:bg-blue-600 active:bg-blue-700 transition-all duration-200\n                  flex items-center gap-1.5 shadow-sm hover:shadow",
                                                        onClick: handleCommentSubmit
                                                      })
                                                ],
                                                className: "flex items-center gap-2"
                                              }),
                                          className: "border-t border-gray-200 bg-white p-2 flex-shrink-0"
                                        })
                                  ],
                                  className: "flex flex-col items-stretch h-full"
                                }),
                            className: state.sidebarExpanded ? "w-1/2 bg-white flex flex-col overflow-hidden transition-all duration-300" : "w-3/4 bg-white flex flex-col overflow-hidden transition-all duration-300"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("span", {
                                                          children: Js_string.charAt(0, Ticket$ReactHooksTemplate.name(ticket)).toUpperCase(),
                                                          className: "text-white text-sm font-bold"
                                                        }),
                                                    className: "w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center flex-shrink-0 shadow-md"
                                                  }),
                                              JsxRuntime.jsx("h3", {
                                                    children: Ticket$ReactHooksTemplate.name(ticket),
                                                    className: "text-sm font-semibold text-gray-900 truncate flex-1"
                                                  })
                                            ],
                                            className: "flex items-center gap-2 mb-2"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("img", {
                                                            className: "h-3.5 w-3.5 mr-1.5 flex-shrink-0",
                                                            src: Image$ReactHooksTemplate.phone
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Msisdn.show, Ticket$ReactHooksTemplate.msisdn(ticket)),
                                                            className: "truncate"
                                                          })
                                                    ],
                                                    className: "flex items-center text-gray-600"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("img", {
                                                            className: "h-3.5 w-3.5 mr-1.5 flex-shrink-0",
                                                            src: Image$ReactHooksTemplate.email
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Ticket$ReactHooksTemplate.email(ticket)),
                                                            className: "truncate"
                                                          })
                                                    ],
                                                    className: "flex items-center text-gray-600"
                                                  })
                                            ],
                                            className: "space-y-1.5 text-xs"
                                          })
                                    ],
                                    className: "bg-white rounded-lg border border-gray-200 p-3 mb-3"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      tmp,
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("button", {
                                                    children: [
                                                      JsxRuntime.jsx("span", {
                                                            children: "Ticket Details",
                                                            className: "font-medium text-xs text-gray-900"
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx("img", {
                                                                  className: "h-3 w-3",
                                                                  src: Image$ReactHooksTemplate.chevronDown
                                                                }),
                                                            className: "transition-transform duration-200 " + (
                                                              accordionState.ticketTab ? "rotate-180" : ""
                                                            )
                                                          })
                                                    ],
                                                    className: "w-full flex justify-between items-center p-2 hover:bg-gray-50 transition-colors duration-200 border-b border-gray-100",
                                                    onClick: (function (param) {
                                                        Curry._1(setAccordionState, (function (accordionState) {
                                                                return {
                                                                        feedbackTab: accordionState.feedbackTab,
                                                                        ticketTab: !accordionState.ticketTab,
                                                                        campaignTab: accordionState.campaignTab,
                                                                        customerDetailsTab: accordionState.customerDetailsTab
                                                                      };
                                                              }));
                                                      })
                                                  }),
                                              accordionState.ticketTab ? JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("span", {
                                                                      children: "Priority",
                                                                      className: "text-xs text-gray-600"
                                                                    }),
                                                                JsxRuntime.jsx("span", {
                                                                      children: TicketCategory$ReactHooksTemplate.name(Ticket$ReactHooksTemplate.ticketCategory(ticket)),
                                                                      className: "text-xs text-gray-900 font-medium"
                                                                    })
                                                              ],
                                                              className: "flex justify-between items-center p-1.5 bg-white rounded border border-gray-200"
                                                            }),
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("span", {
                                                                      children: "Status",
                                                                      className: "text-xs text-gray-600"
                                                                    }),
                                                                JsxRuntime.jsx("span", {
                                                                      children: Ticket$ReactHooksTemplate.Status.toString(Ticket$ReactHooksTemplate.status(ticket)),
                                                                      className: "text-xs text-gray-900 font-medium"
                                                                    })
                                                              ],
                                                              className: "flex justify-between items-center p-1.5 bg-white rounded border border-gray-200"
                                                            })
                                                      ],
                                                      className: "p-2 bg-gray-50 space-y-1"
                                                    }) : null
                                            ],
                                            className: "bg-white rounded-lg border border-gray-200 overflow-hidden"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("button", {
                                                    children: [
                                                      JsxRuntime.jsx("span", {
                                                            children: "Customer Details",
                                                            className: "font-medium text-xs text-gray-900"
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx("img", {
                                                                  className: "h-3 w-3",
                                                                  src: Image$ReactHooksTemplate.chevronDown
                                                                }),
                                                            className: "transition-transform duration-200 " + (
                                                              accordionState.customerDetailsTab ? "rotate-180" : ""
                                                            )
                                                          })
                                                    ],
                                                    className: "w-full flex justify-between items-center p-2 hover:bg-gray-50 transition-colors duration-200 border-b border-gray-100",
                                                    onClick: (function (param) {
                                                        Curry._1(setAccordionState, (function (accordionState) {
                                                                return {
                                                                        feedbackTab: accordionState.feedbackTab,
                                                                        ticketTab: accordionState.ticketTab,
                                                                        campaignTab: accordionState.campaignTab,
                                                                        customerDetailsTab: !accordionState.customerDetailsTab
                                                                      };
                                                              }));
                                                      })
                                                  }),
                                              tmp$2
                                            ],
                                            className: "bg-white rounded-lg border border-gray-200 overflow-hidden"
                                          }),
                                      tmp$3
                                    ],
                                    className: "space-y-3"
                                  })
                            ],
                            className: state.sidebarExpanded ? "w-1/2 bg-gray-50 border-l-2 border-gray-300 pb-3 px-3 overflow-y-auto transition-all duration-300" : "w-1/4 bg-gray-50 border-l-2 border-gray-300 pb-2 px-2 overflow-y-auto transition-all duration-300"
                          }),
                      tmp$5,
                      match$7[0] ? JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h3", {
                                                    children: "Assign Ticket",
                                                    className: "text-base font-semibold text-gray-900"
                                                  }),
                                              JsxRuntime.jsx("button", {
                                                    children: JsxRuntime.jsx("img", {
                                                          className: "h-4 w-4",
                                                          src: Image$ReactHooksTemplate.closeIcon
                                                        }),
                                                    className: "text-gray-400 hover:text-gray-600 transition-colors",
                                                    onClick: (function (param) {
                                                        Curry._1(setOpenAssignModal, (function (param) {
                                                                return false;
                                                              }));
                                                      })
                                                  })
                                            ],
                                            className: "p-4 border-b border-gray-200 flex justify-between items-center"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("label", {
                                                    children: "Select Agent",
                                                    className: "block text-xs font-medium text-gray-700 mb-2"
                                                  }),
                                              JsxRuntime.jsx("select", {
                                                    children: $$Array.of_list(List.map((function (assignee) {
                                                                return JsxRuntime.jsx("option", {
                                                                            children: emailText(assignee),
                                                                            value: emailText(assignee)
                                                                          }, String(Ticket$ReactHooksTemplate.Assignee.id(assignee)));
                                                              }), {
                                                              hd: Ticket$ReactHooksTemplate.Assignee.empty,
                                                              tl: props.agents
                                                            })),
                                                    className: "block w-full border border-gray-300 px-3 py-2 bg-white rounded\n                    focus:outline-none focus:ring-2 focus:ring-palatinateblue focus:border-palatinateblue\n                    text-sm transition-all duration-200",
                                                    onChange: props.handleAssigneeSelection
                                                  })
                                            ],
                                            className: "p-4"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("button", {
                                                    children: "Cancel",
                                                    className: "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50\n                    rounded py-2 px-4 text-sm font-medium transition-all duration-200",
                                                    onClick: (function (param) {
                                                        Curry._1(setOpenAssignModal, (function (param) {
                                                                return false;
                                                              }));
                                                      })
                                                  }),
                                              JsxRuntime.jsx("button", {
                                                    children: "Assign",
                                                    className: "bg-palatinateblue text-white hover:bg-blue-700\n                    rounded py-2 px-4 text-sm font-medium transition-all duration-200 shadow-sm",
                                                    onClick: (function (param) {
                                                        Curry._1(assignTicket, Ticket$ReactHooksTemplate.id(ticket));
                                                        Curry._1(setOpenAssignModal, (function (param) {
                                                                return false;
                                                              }));
                                                      })
                                                  })
                                            ],
                                            className: "p-4 border-t border-gray-200 flex justify-end gap-2 bg-gray-50"
                                          })
                                    ],
                                    className: "bg-white rounded-lg shadow-2xl border border-gray-200 w-96 max-w-md",
                                    onClick: (function (e) {
                                        e.stopPropagation();
                                      })
                                  }),
                              className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
                              onClick: (function (param) {
                                  Curry._1(setOpenAssignModal, (function (param) {
                                          return false;
                                        }));
                                })
                            }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                    ],
                    className: "flex overflow-hidden h-full relative",
                    style: {
                      height: "calc(100vh - 10.8rem)"
                    }
                  }, String(Ticket$ReactHooksTemplate.id(ticket))),
              className: "h-full flex flex-col"
            });
}

var make = TicketView;

exports.updateTicket = updateTicket;
exports.isValidComment = isValidComment;
exports.emptyState = emptyState;
exports.initialAccordionState = initialAccordionState;
exports.page = page;
exports.make = make;
/* react Not a pure module */
